var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-breadcrumb',{staticClass:"container",attrs:{"id":"breadcrumb","items":_vm.breadItems}})
}
var staticRenderFns = []

export { render, staticRenderFns }